<button
    #buttonElement
    class="button outline-none disabled:cursor-not-allowed disabled:opacity-50 items-center justify-center transition-colors duration-150 ease-in-out focus:ring-2 focus:ring-gray-1300 focus:ring-opacity-50"
    [ngClass]="buttonClasses"
    [type]="type"
    [disabled]="isButtonDisabled || loading"
    [attr.aria-label]="ariaLabel || label"
    [attr.aria-disabled]="isButtonDisabled || loading"
    [attr.aria-busy]="loading"
    [attr.tabindex]="tabindex"
    [autofocus]="autofocus"
    (click)="handleClick($event)"
    (keydown.enter)="handleClick($event)"
    (focus)="handleFocus($event)"
    (blur)="handleBlur($event)"
    >
    
    <!-- Loading Spinner -->
    <ng-container *ngIf="loading">
      <ng-container *ngIf="loadingIconTemplate; else defaultLoadingIcon">
        <ng-container *ngTemplateOutlet="loadingIconTemplate"></ng-container> 
      </ng-container>
      <ng-template #defaultLoadingIcon>
        <svg *ngIf="!loadingIcon" 
             class="animate-spin mr-2" 
             [ngClass]="[loaderSize, computedLoaderColor]" 
             viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <NiFormIcon *ngIf="loadingIcon" 
                [icon]="loadingIcon" 
                [iconClass]="loaderSize + ' ' + computedLoaderColor + ' animate-spin mr-2'">
        </NiFormIcon>
      </ng-template>
    </ng-container>

    <!-- Leading Icon -->
    <ng-container *ngIf="(leadingIcon || icon) && !loading">
      <NiFormIcon [icon]="leadingIcon || icon" [iconClass]="leadingIconClass + (icon ? ' m-1 ni-icon-only' : '')" (onClick)="handleLeadingIconClick($event)"></NiFormIcon>
    </ng-container>

    <!-- Label -->
    <span [class]="'inline-block align-middle font-archivo ' + ((leadingIcon || icon) && !loading ? ' pl-[4px]' : '') +((lineHeight? lineHeight : ''))">
      {{ effectiveLabel }}
    </span>

    <!-- Trailing Icon -->
    <ng-container *ngIf="trailingIcon && !loading">
      <NiFormIcon [icon]="trailingIcon" [iconClass]="trailingIconClass + ' ml-2'" (onClick)="handleTrailingIconClick($event)"></NiFormIcon>
    </ng-container>

    <!-- Badge -->
    <span *ngIf="badge" 
          class="ml-2 px-2 py-0.5 rounded-full text-xs font-semibold"
          [ngClass]="badgeColorClass + ' ' + badgeClass">
      {{ badge }}
    </span>
</button>